import { useQuery } from "@tanstack/react-query";

import axios from "../../../../../../utils/axiosInceptor";
import { dashboardApiV1Endpoint } from "../../../../../../api/v1/endpoints";

const getRenewalDeclinedReasons = async (body) => {
  const url = `${dashboardApiV1Endpoint}/dashboard/renewal-declined-reasons`;
  const response = await axios.post(url, body);
  return response?.data?.result;
};

export const useGetRenewalReasons = (filterData) => {
  const { data, isLoading } = useQuery({
    queryKey: ["renewal-declined-reasons", filterData?.queryParams],
    queryFn: () => getRenewalDeclinedReasons(filterData?.queryParams),
    staleTime: 1000 * 60 * 5, // ✅ 5 minutes
    refetchOnWindowFocus: false, // 👈 disable auto refetch when window regains focus
  });

  return {
    renewalReasons: data ?? [],
    isLoading: isLoading,
  };
};
